import { compareHoleSlots } from './holeSlots';

// Every field on the player schema that an admin can put in an export.
export const PLAYER_CSV_COLUMNS = [
	{ key: 'name', label: 'Name' },
	{ key: 'email', label: 'Email' },
	{ key: 'shirtSize', label: 'Shirt Size' },
	{ key: 'holeAssignment', label: 'Hole' },
	{ key: 'groupId', label: 'Group ID' },
	{ key: 'paymentId', label: 'Payment ID' },
];

// Payment ids are left out unless the admin asks for them.
export const DEFAULT_PLAYER_CSV_COLUMNS = ['name', 'email', 'shirtSize', 'holeAssignment', 'groupId'];

const NEEDS_QUOTES = /[",\r\n]/;
const STARTS_A_FORMULA = /^[=+\-@\t\r]/;

function escapeCell(value) {
	let text = value === undefined || value === null ? '' : String(value);

	// Player names come from a public form, so stop a spreadsheet from
	// treating one as a formula when the file is opened.
	if (STARTS_A_FORMULA.test(text)) {
		text = `'${ text }`;
	}

	if (NEEDS_QUOTES.test(text) || text !== text.trim()) {
		return `"${ text.replace(/"/g, '""') }"`;
	}

	return text;
}

// Rows follow the course (1A, 1B, 2A, ...) with unassigned groups last.
// Groups stay together, players are alphabetical inside a group.
function byHoleThenGroupThenName(a, b) {
	const holeOrder = compareHoleSlots(a.holeAssignment, b.holeAssignment);

	if (holeOrder !== 0) {
		return holeOrder;
	}

	const groupOrder = String(a.groupId || '').localeCompare(String(b.groupId || ''));

	return groupOrder !== 0
		? groupOrder
		: String(a.name || '').localeCompare(String(b.name || ''));
}

export function playersToCsv(players, columnKeys) {
	const columns = PLAYER_CSV_COLUMNS.filter(({key}) => columnKeys.includes(key));

	if (!columns.length) {
		return '';
	}

	const header = columns.map(({label}) => escapeCell(label)).join(',');
	const rows = [...players].sort(byHoleThenGroupThenName).map(player =>
		columns.map(({key}) => escapeCell(player[key])).join(',')
	);

	return [header, ...rows].join('\r\n');
}

export function playerCsvFilename(date = new Date()) {
	const pad = (number) => String(number).padStart(2, '0');
	const stamp = `${ date.getFullYear() }-${ pad(date.getMonth() + 1) }-${ pad(date.getDate()) }`;

	return `fore-nora-players-${ stamp }.csv`;
}

export function downloadCsv(csv, filename) {
	// The byte order mark keeps Excel from mangling accented characters.
	const blob = new Blob([`﻿${ csv }`], {type: 'text/csv;charset=utf-8;'});
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');

	link.href = url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
}
